import React from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import PageHeader from "../../components/PageHeader";
import DataComponent from "../../components/DataComponent";

const TestButtons = (props) => {
  return (
    <>
      <PageHeader title="WeCake - Buttons" />

      <Card>
        <CardBody>
          <CardTitle>Button Size</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            <code>.btn-lg</code>,
            <code>.btn-md</code>,
            <code>.btn-sm</code>
            className for additional buttons size.
          </CardSubtitle>
          <br />

          <div className="button-items">
            <DataComponent field={{
              type: "button",
              label: "Large",
              size: "lg",
              action: () => { console.log('large button click') }
            }}
            />
            <DataComponent field={{
              type: "button",
              label: "Medium",
              size: "md",
              action: () => { console.log('Medium button click') }
            }}
            />
            <DataComponent field={{
              type: "button",
              label: "Small",
              size: "sm",
              action: () => { console.log('Small button click') }
            }}
            />
            <button type="button" className="btn btn-primary btn-lg">
              Large
            </button>
            <button type="button" className="btn btn-primary btn-md">
              Medium
            </button>
            <button type="button" className="btn btn-primary btn-sm">
              Small
            </button>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Button Style</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            <code>.btn-primary</code>,
            <code>.btn-secondary</code>,
            <code>.btn-line</code>,
            <code>.btn-gray-line</code>,
            <code>.btn-gray</code>,
            <code>.btn-text</code>,
            className for additional buttons style.
          </CardSubtitle>
          <br />

          <div className="button-items">

            <DataComponent field={{
              type: "button",
              color: "primary",
              label: "Primary",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "secondary",
              label: "Secondary",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Line",
              label: "Line",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "gray-line",
              label: "Gray Line",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Gray",
              label: "Gray",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Text",
              label: "Text",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "green",
              label: "green",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "red",
              label: "red",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "success",
              label: "success",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "danger",
              label: "danger",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "warning",
              label: "warning",
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "info",
              label: "info",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "light",
              label: "light",
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "dark",
              label: "dark",
            }}
            />
          </div>
        </CardBody>
      </Card>


      <Card>
        <CardBody>
          <CardTitle>Button Hover</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            <code>.btn-hover or hover</code>,
            className for additional buttons state.
          </CardSubtitle>
          <br />

          <div className="button-items">

            <DataComponent field={{
              type: "button",
              color: "primary",
              label: "Primary",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "secondary",
              label: "Secondary",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Line",
              label: "Line",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "gray-line",
              label: "Gray Line",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Gray",
              label: "Gray",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "Text",
              label: "Text",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "green",
              label: "green",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "red",
              label: "red",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "success",
              label: "success",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "danger",
              label: "danger",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "warning",
              label: "warning",
              hover: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "info",
              label: "info",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "light",
              label: "light",
              hover: true
            }}
            />
            <DataComponent field={{
              type: "button",
              color: "dark",
              label: "dark",
              hover: true
            }}
            />
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Button Disabled</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            <code>.btn-disabled or disabled</code>,
            className for additional buttons state.
          </CardSubtitle>
          <br />

          <div className="button-items">
            <DataComponent field={{
              type: "button",
              color: "primary",
              label: "Primary",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "secondary",
              label: "Secondary",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "Line",
              label: "Line",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "gray-line",
              label: "Gray Line",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "Gray",
              label: "Gray",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "Text",
              label: "Text",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "green",
              label: "green",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "red",
              label: "red",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "success",
              label: "success",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "danger",
              label: "danger",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "warning",
              label: "warning",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "info",
              label: "info",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "light",
              label: "light",
              disabled: true
            }}
            />

            <DataComponent field={{
              type: "button",
              color: "dark",
              label: "dark",
              disabled: true
            }}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default TestButtons;
